/**
 * Read Decision mode from run working_set.decisionRun.
 * Legacy EXPLORE values normalize to PROVISIONAL.
 */

export type UiDecisionMode = 'PROVISIONAL' | 'VERIFIED' | 'EVIDENCE_ONLY';

export function readDecisionModeFromWorkingSet(
  workingSet: Record<string, unknown> | null | undefined
): UiDecisionMode | null {
  if (!workingSet || typeof workingSet !== 'object') return null;
  const raw = workingSet['decisionRun'];
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const mode = (raw as Record<string, unknown>)['mode'];
  if (mode === 'EXPLORE' || mode === 'PROVISIONAL') return 'PROVISIONAL';
  if (mode === 'VERIFIED' || mode === 'EVIDENCE_ONLY') return mode;
  return null;
}

/** Session instanceFields keys present on the run (override signal for UI hint). */
export function readSessionOverrideHint(
  workingSet: Record<string, unknown> | null | undefined
): boolean {
  if (!workingSet || typeof workingSet !== 'object') return false;
  const fields = workingSet['instanceFields'];
  return Boolean(fields && typeof fields === 'object' && !Array.isArray(fields) && Object.keys(fields).length > 0);
}
